import { ReactNode } from 'react';
import { NavBar } from './NavBar';
import { Footer } from './Footer';

interface BlogLayoutProps {
  children: ReactNode;
}

export function BlogLayout({ children }: BlogLayoutProps) {
  return (
    <div className="app">
      <NavBar />
      <main className="site-shell page-shell">{children}</main>
      <Footer />
    </div>
  );
}
